// extracted by mini-css-extract-plugin
export var card = "experience-module--card---X67u";
export var logo = "experience-module--logo--zRkjI";